var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BackDropComponent from "@/components/BackDrop";
import { getAccountTypeRequest, getActiveWalletPlanRequest, getCompanyMetaDataRequest, getDeclarationFormRequest, getDeclarationFormReset, getDeclarationStatusRequest, getDeclarationStatusReset, getGstCertListRequest, getKycInfoRequest, getRemittancePayoutCycleRequest, getSellerWalletPlansRequest, updateAccountTypeRequest, updateDeclarationFormstateRequest, updateDeclarationFormstateReset, updateKYCstateRequest, updateKYCstateReset, updateRemittancePayoutCycleRequest, updateSellerWalletPlanRequest, } from "@/redux/actions";
import { detectFileTypeFromBlob, getDateString, handleDownload } from "@/utils/Common";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Breadcrumbs, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, } from "@mui/material";
import { ArrowBack, CalendarToday, CheckCircle, ContentCopy, EventRepeat, FingerprintOutlined, InfoOutlined, LayersOutlined, LockOutlined, ManageAccounts, NavigateNext, ReceiptLong, StorefrontOutlined, VerifiedUser, WarningAmber, } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../scss/main.scss";
import KYCdetails from "./KYCdetails";
import "./TenantManager.scss";
const getKycBadgeClass = (status) => {
    const s = status === null || status === void 0 ? void 0 : status.toLowerCase();
    if (s === "verified")
        return "tm_badge_verified";
    if (s === "rejected")
        return "tm_badge_rejected";
    return "tm_badge_pending";
};
const getGstCertBadgeClass = (status) => {
    const s = status === null || status === void 0 ? void 0 : status.toLowerCase();
    if (s === "approved")
        return "tm_badge_verified";
    if (s === "rejected")
        return "tm_badge_rejected";
    if (s === "pending")
        return "tm_badge_pending";
    return "tm_badge_pending"; // null / not submitted
};
const TenantManagerDetails = () => {
    var _a, _b;
    const [activeAccountType, setActiveAccountType] = React.useState();
    const [tenantId, setTenantId] = React.useState(null);
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const UpdateKYCState = useSelector((state) => state.updateKYCstateReducer);
    const [walletTiers, setWalletTiers] = React.useState([]);
    const [activePlan, setActivePlan] = React.useState("");
    const [companyName, setCompanyName] = React.useState("");
    const [userName, setUserName] = React.useState("");
    const [emailId, setEmailID] = React.useState("");
    const [phoneNumber, setPhoneNumber] = React.useState("");
    const [tenantType, setTenantType] = React.useState("");
    const [createdAt, setCreatedAt] = React.useState("");
    const [accountType, setAccountType] = React.useState("");
    const [kycStatus, setKycStatus] = React.useState("");
    const [selectedTier, setSelectedTier] = React.useState("Prepaid");
    const SellerWalletPlansState = useSelector((state) => state.getSellerWalletPlansReducer);
    const SellerActivePlanState = useSelector((state) => state.getActiveWalletPlanReducer);
    const UpdateActiveWalletPlanState = useSelector((state) => state.updateActiveWalletPlanReducer);
    const ActiveAccountTypeState = useSelector((state) => state.getActiveAccountTypeReducer);
    const UpdateActiveAccountTypeState = useSelector((state) => state.updateActiveAccountTypeReducer);
    const getCompanyMetaDataState = useSelector((state) => state.getCompanyMetaDataReducer);
    const getKycInfoState = useSelector((state) => state.getKycInfoReducer);
    const downloadDeclarationFormState = useSelector((state) => state.getDeclarationFormReducer);
    const UpdateDeclarationState = useSelector((state) => state.updateDeclarationFormstateReducer);
    const getDeclarationStatusState = useSelector((state) => state.getDeclarationStatusReducer);
    const [gstCertList, setGstCertList] = React.useState([]);
    const getGstCertListState = useSelector((state) => state.getGSTCertificateListReducer);
    const [declarationExist, setDeclarationExist] = React.useState(false);
    const formatGstCertStatus = (status) => (status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : "Not Submitted");
    // Remittance Payout cycle
    const [activePayoutCycle, setActivePayoutCycle] = React.useState("");
    const [currentBillingCycle, setCurrentBillingCycle] = React.useState("");
    const [currentBillingCycleStartTimestamp, setCurrentBillingCycleStartTimestamp] = React.useState("");
    const [upcomingBillingCycle, setupcomingBillingCycle] = React.useState("");
    const [upcomingBillingCycleStartTimestamp, setUpcomingBillingCycleStartTimestamp] = React.useState("");
    const [selectedPayoutCycle, setSelectedPayoutCycle] = React.useState("");
    const getRemittancePayoutCycleState = useSelector((state) => state.getRemittnacePayoutCycleReducer);
    const UpdateRemittancePayoutCycleState = useSelector((state) => state.updateRemittnacePayoutCycleReducer);
    // Confirmation dialog state
    const [accountTypeConfirmOpen, setAccountTypeConfirmOpen] = React.useState(false);
    const [kycConfirmOpen, setKycConfirmOpen] = React.useState(false);
    const [pendingKycAction, setPendingKycAction] = React.useState("");
    const location = useLocation();
    const selectedTenant = (_a = location.state) === null || _a === void 0 ? void 0 : _a.selectedTenant;
    React.useEffect(() => {
        const updateTenantId = () => {
            const id = localStorage.getItem("tenantId");
            setTenantId(id);
        };
        updateTenantId();
        window.addEventListener("tenantIdChanged", updateTenantId);
        return () => {
            window.removeEventListener("tenantIdChanged", updateTenantId);
        };
    }, []);
    React.useEffect(() => {
        setIsBackOpenOpen(true);
        const id = localStorage.getItem("tenantId");
        dispatch(getSellerWalletPlansRequest({}));
        dispatch(getActiveWalletPlanRequest({ tenantId: id }));
        dispatch(getAccountTypeRequest({ tenantId: id }));
        dispatch(getRemittancePayoutCycleRequest({ tenantId: id }));
        dispatch(getCompanyMetaDataRequest({ tenantId: id }));
        dispatch(getKycInfoRequest({ tenantId: id }));
        dispatch(getDeclarationStatusRequest({ type: "GST_DECLARATION", companyId: id }));
        dispatch(getGstCertListRequest({ companyId: id }));
    }, [tenantId]);
    React.useEffect(() => {
        if (SellerWalletPlansState && (SellerWalletPlansState === null || SellerWalletPlansState === void 0 ? void 0 : SellerWalletPlansState.walletPlansData)) {
            setIsBackOpenOpen(false);
            setWalletTiers((SellerWalletPlansState === null || SellerWalletPlansState === void 0 ? void 0 : SellerWalletPlansState.walletPlansData) || []);
        }
        else if (SellerWalletPlansState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(SellerWalletPlansState.error.message, {
                variant: "error",
            });
        }
    }, [SellerWalletPlansState]);
    React.useEffect(() => {
        if (ActiveAccountTypeState && (ActiveAccountTypeState === null || ActiveAccountTypeState === void 0 ? void 0 : ActiveAccountTypeState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            setActiveAccountType(ActiveAccountTypeState.ActivePlanData);
        }
        else if (ActiveAccountTypeState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(ActiveAccountTypeState.error.message, {
                variant: "error",
            });
        }
    }, [ActiveAccountTypeState]);
    React.useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (getCompanyMetaDataState && (getCompanyMetaDataState === null || getCompanyMetaDataState === void 0 ? void 0 : getCompanyMetaDataState.data)) {
            setIsBackOpenOpen(false);
            setCompanyName(((_a = getCompanyMetaDataState.data) === null || _a === void 0 ? void 0 : _a.name) || "NA");
            setUserName(((_b = getCompanyMetaDataState.data.userProfileList[0]) === null || _b === void 0 ? void 0 : _b.firstName) + " " + ((_c = getCompanyMetaDataState.data.userProfileList[0]) === null || _c === void 0 ? void 0 : _c.lastName) || "NA");
            setTenantType(getCompanyMetaDataState.data.tenantType || "NA");
            setCreatedAt(getCompanyMetaDataState.data.created_at || "-");
            setEmailID(((_d = getCompanyMetaDataState.data.userProfileList[0]) === null || _d === void 0 ? void 0 : _d.emailAddress) || "NA");
            setPhoneNumber(((_e = getCompanyMetaDataState.data.userProfileList[0]) === null || _e === void 0 ? void 0 : _e.phoneNumber) || "NA");
        }
        else if (getCompanyMetaDataState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(getCompanyMetaDataState.error.message, {
                variant: "error",
            });
        }
    }, [getCompanyMetaDataState]);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (getKycInfoState && (getKycInfoState === null || getKycInfoState === void 0 ? void 0 : getKycInfoState.data)) {
            setIsBackOpenOpen(false);
            setAccountType(((_b = (_a = getKycInfoState.data) === null || _a === void 0 ? void 0 : _a.kycInfo) === null || _b === void 0 ? void 0 : _b.accountType) || "NA");
            setKycStatus(((_d = (_c = getKycInfoState.data) === null || _c === void 0 ? void 0 : _c.kycInfo) === null || _d === void 0 ? void 0 : _d.status) || "NA");
        }
        else if (getKycInfoState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(getKycInfoState.error.message, {
                variant: "error",
            });
        }
    }, [getKycInfoState]);
    React.useEffect(() => {
        var _a;
        if (SellerActivePlanState && (SellerActivePlanState === null || SellerActivePlanState === void 0 ? void 0 : SellerActivePlanState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            setActivePlan(((_a = SellerActivePlanState === null || SellerActivePlanState === void 0 ? void 0 : SellerActivePlanState.ActivePlanData) === null || _a === void 0 ? void 0 : _a.tierName) || "");
        }
        else if (SellerActivePlanState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(SellerActivePlanState.error.message, {
                variant: "error",
            });
        }
    }, [SellerActivePlanState]);
    React.useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (getRemittancePayoutCycleState && (getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data)) {
            setIsBackOpenOpen(false);
            setCurrentBillingCycle(((_b = (_a = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _a === void 0 ? void 0 : _a.currentConfig) === null || _b === void 0 ? void 0 : _b.calculationCycle) || "");
            setCurrentBillingCycleStartTimestamp(((_d = (_c = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _c === void 0 ? void 0 : _c.currentConfig) === null || _d === void 0 ? void 0 : _d.startTimestamp) || "");
            setupcomingBillingCycle(((_f = (_e = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _e === void 0 ? void 0 : _e.upcomingConfig) === null || _f === void 0 ? void 0 : _f.calculationCycle) || "");
            setUpcomingBillingCycleStartTimestamp(((_h = (_g = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _g === void 0 ? void 0 : _g.upcomingConfig) === null || _h === void 0 ? void 0 : _h.startTimestamp) || "");
            setActivePayoutCycle(((_k = (_j = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _j === void 0 ? void 0 : _j.currentConfig) === null || _k === void 0 ? void 0 : _k.remittanceCycle) || "");
        }
        else if (getRemittancePayoutCycleState.error) {
            enqueueSnackbar(getRemittancePayoutCycleState.error.message, {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [getRemittancePayoutCycleState]);
    React.useEffect(() => {
        var _a, _b;
        if (UpdateRemittancePayoutCycleState && (UpdateRemittancePayoutCycleState === null || UpdateRemittancePayoutCycleState === void 0 ? void 0 : UpdateRemittancePayoutCycleState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            setActivePayoutCycle(((_b = (_a = UpdateRemittancePayoutCycleState === null || UpdateRemittancePayoutCycleState === void 0 ? void 0 : UpdateRemittancePayoutCycleState.ActivePlanData) === null || _a === void 0 ? void 0 : _a.currentConfig) === null || _b === void 0 ? void 0 : _b.remittanceCycle) || "");
            enqueueSnackbar("Remittance cycle for the tenant updated successfully.", {
                variant: "success",
            });
        }
        else if (UpdateRemittancePayoutCycleState.error) {
            enqueueSnackbar(UpdateRemittancePayoutCycleState.error.message, {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [UpdateRemittancePayoutCycleState]);
    React.useEffect(() => {
        if (UpdateActiveWalletPlanState && (UpdateActiveWalletPlanState === null || UpdateActiveWalletPlanState === void 0 ? void 0 : UpdateActiveWalletPlanState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Wallet plan updated successfully.", {
                variant: "success",
            });
        }
        else if (UpdateActiveWalletPlanState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateActiveWalletPlanState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateActiveWalletPlanState]);
    React.useEffect(() => {
        if (UpdateActiveAccountTypeState && UpdateActiveAccountTypeState.ActivePlanData) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Account Type updated successfully.", {
                variant: "success",
            });
        }
        else if (UpdateActiveAccountTypeState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateActiveAccountTypeState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateActiveAccountTypeState]);
    React.useEffect(() => {
        if (UpdateKYCState && UpdateKYCState.data) {
            enqueueSnackbar(`KYC state updated successfully.`, {
                variant: "success",
            });
            dispatch(updateKYCstateReset());
            setIsBackOpenOpen(false);
        }
        else if (UpdateKYCState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateKYCState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateKYCState]);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (downloadDeclarationFormState && downloadDeclarationFormState.data) {
            const blob = downloadDeclarationFormState.data;
            const processDownload = () => __awaiter(void 0, void 0, void 0, function* () {
                const detected = yield detectFileTypeFromBlob(blob);
                const extension = detected === "unknown" ? "pdf" : detected; // fallback if signature doesn't match either
                handleDownload(blob, extension);
                dispatch(getDeclarationFormReset());
                setIsBackOpenOpen(false);
            });
            processDownload();
        }
        else if (downloadDeclarationFormState.error) {
            console.log("downloadDeclarationFormState.error", downloadDeclarationFormState.error);
            setIsBackOpenOpen(false);
            enqueueSnackbar(((_d = (_c = (_b = (_a = downloadDeclarationFormState.error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) === null || _d === void 0 ? void 0 : _d[0]) || "Failed to download form.", {
                variant: "ErrorMessage",
            });
            dispatch(getDeclarationFormReset());
        }
    }, [downloadDeclarationFormState]);
    React.useEffect(() => {
        if (getGstCertListState && (getGstCertListState === null || getGstCertListState === void 0 ? void 0 : getGstCertListState.data)) {
            setIsBackOpenOpen(false);
            setGstCertList(getGstCertListState.data || []);
        }
        else if (getGstCertListState === null || getGstCertListState === void 0 ? void 0 : getGstCertListState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(getGstCertListState.error.message, {
                variant: "error",
            });
        }
    }, [getGstCertListState]);
    React.useEffect(() => {
        if (UpdateDeclarationState && UpdateDeclarationState.data) {
            enqueueSnackbar(`State updated successfully.`, {
                variant: "success",
            });
            dispatch(updateDeclarationFormstateReset());
            setIsBackOpenOpen(false);
        }
        else if (UpdateDeclarationState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateDeclarationState.error.message, {
                variant: "error",
            });
            dispatch(updateDeclarationFormstateReset());
        }
    }, [UpdateDeclarationState]);
    React.useEffect(() => {
        var _a, _b;
        if (getDeclarationStatusState && getDeclarationStatusState.data) {
            const exists = ((_a = getDeclarationStatusState.data) === null || _a === void 0 ? void 0 : _a.exists) || false;
            setDeclarationExist(exists);
            dispatch(getDeclarationStatusReset());
            setIsBackOpenOpen(false);
        }
        else if (getDeclarationStatusState === null || getDeclarationStatusState === void 0 ? void 0 : getDeclarationStatusState.error) {
            console.log("getDeclarationStatusState.error", getDeclarationStatusState === null || getDeclarationStatusState === void 0 ? void 0 : getDeclarationStatusState.error);
            setIsBackOpenOpen(false);
            enqueueSnackbar((_b = getDeclarationStatusState === null || getDeclarationStatusState === void 0 ? void 0 : getDeclarationStatusState.error) === null || _b === void 0 ? void 0 : _b.message, {
                variant: "error",
            });
            dispatch(getDeclarationStatusReset());
        }
    }, [getDeclarationStatusState]);
    const handleKYCstateUpdate = (status) => {
        setIsBackOpenOpen(true);
        dispatch(updateKYCstateRequest({
            tenantId: tenantId,
            kycUpdateState: status,
        }));
    };
    const handleSaveAccountType = () => {
        setIsBackOpenOpen(true);
        dispatch(updateAccountTypeRequest({ activeAccountType }));
    };
    const HandleSaveWalletPlan = () => {
        const payload = {
            tenantId: tenantId,
            tenantTier: selectedTier.replace(/\s+/g, ""),
        };
        dispatch(updateSellerWalletPlanRequest(payload));
    };
    const HandleSaveRemittancePayoutCycle = () => {
        if (selectedPayoutCycle === activePayoutCycle) {
            return;
        }
        if (selectedPayoutCycle) {
            setIsBackOpenOpen(true);
            const payload = {
                tenantId: tenantId,
                remittanceCycle: selectedPayoutCycle,
            };
            dispatch(updateRemittancePayoutCycleRequest(payload));
        }
    };
    const handleCopyTenantId = () => {
        if (tenantId) {
            navigator.clipboard.writeText(tenantId);
            enqueueSnackbar("Tenant ID copied to clipboard.", { variant: "success" });
        }
    };
    const formattedAccountType = (type) => {
        var _a, _b;
        return ((_b = (_a = type === null || type === void 0 ? void 0 : type.split("_")) === null || _a === void 0 ? void 0 : _a.map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())) === null || _b === void 0 ? void 0 : _b.join(" ")) || "-";
    };
    const selectedTierData = walletTiers.find((t) => t.tierName === selectedTier);
    const handleDownloadDeclaration = () => {
        setIsBackOpenOpen(true);
        dispatch(getDeclarationFormRequest({
            companyId: tenantId,
            type: "GST_DECLARATION",
        }));
    };
    const handleDeclarationStateUpdate = (status, type) => {
        setIsBackOpenOpen(true);
        dispatch(updateDeclarationFormstateRequest({
            tenantId: tenantId,
            status: status,
            type: type,
        }));
    };
    const handleGstCertStateUpdate = (gstNumber, status, type) => {
        setIsBackOpenOpen(true);
        dispatch(updateDeclarationFormstateRequest({
            tenantId: tenantId,
            gstNumber,
            status,
            type,
        }));
    };
    const handleDownloadGstCertificate = (cert) => {
        setIsBackOpenOpen(true);
        dispatch(getDeclarationFormRequest({
            companyId: tenantId,
            type: "GST_CERTIFICATE",
            gstNumber: cert.gstNumber,
        }));
    };
    return (React.createElement(Box, { sx: { backgroundColor: "#F8FAFC", minHeight: "100vh" } },
        React.createElement(Grid, { container: true, direction: "column", spacing: 3, p: 6 },
            React.createElement(BackDropComponent, { open: isBackOpenOpen }),
            React.createElement(Grid, { item: true },
                React.createElement("div", { className: "tm_page_header" },
                    React.createElement(Breadcrumbs, { separator: React.createElement(NavigateNext, { sx: { fontSize: 14, color: "#94A3B8" } }), sx: { mb: 1.5 } },
                        React.createElement(Typography, { className: "tm_breadcrumb", onClick: () => navigate(-1), sx: { fontSize: 13, cursor: "pointer", "&:hover": { color: "#0f172a" } } }, "Tenant Manager"),
                        React.createElement(Typography, { className: "tm_breadcrumb", sx: { fontSize: 13, color: "#0f172a", fontWeight: 600 } }, companyName || tenantId || "Details")),
                    React.createElement(Box, { display: "flex", alignItems: "center", gap: 1, mb: 2 },
                        React.createElement(IconButton, { size: "small", onClick: () => navigate(-1), sx: {
                                color: "#64748B",
                                backgroundColor: "#F1F5F9",
                                border: "1px solid #E2E8F0",
                                borderRadius: "8px",
                                p: 0.75,
                                "&:hover": { backgroundColor: "#E2E8F0", color: "#0f172a" },
                            } },
                            React.createElement(ArrowBack, { sx: { fontSize: 16 } })),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 700, fontSize: "22px", color: "#0f172a", letterSpacing: "-0.3px" } }, "Profile & Company Details")),
                    React.createElement(Box, { sx: {
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            gap: 1,
                            p: 1.5,
                            backgroundColor: "#ffffff",
                            border: "1px solid #E2E8F0",
                            borderRadius: "10px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                        } },
                        React.createElement(Tooltip, { title: "Click to copy Tenant ID", placement: "bottom" },
                            React.createElement(Box, { onClick: handleCopyTenantId, sx: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.75,
                                    fontFamily: "monospace",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    color: "#334155",
                                    backgroundColor: "#F8FAFC",
                                    border: "1px solid #CBD5E1",
                                    borderRadius: "6px",
                                    px: 1.25,
                                    py: 0.5,
                                    cursor: "pointer",
                                    transition: "all 150ms ease",
                                    "&:hover": { backgroundColor: "#EFF6FF", borderColor: "#93C5FD", color: "#1D4ED8" },
                                } },
                                React.createElement(FingerprintOutlined, { sx: { fontSize: 14 } }),
                                tenantId || "—",
                                React.createElement(ContentCopy, { sx: { fontSize: 11, opacity: 0.6 } }))),
                        React.createElement(Box, { sx: { width: "1px", height: 20, backgroundColor: "#E2E8F0", mx: 0.5 } }),
                        kycStatus && (React.createElement(Box, { sx: Object.assign({ display: "inline-flex", alignItems: "center", gap: 0.5, px: 1.25, py: 0.5, borderRadius: "6px", fontSize: 12, fontWeight: 600, fontFamily: "Poppins" }, (kycStatus.toLowerCase() === "verified"
                                ? { backgroundColor: "#F0FDF4", color: "#15803D", border: "1px solid #BBF7D0" }
                                : kycStatus.toLowerCase() === "rejected"
                                    ? { backgroundColor: "#FEF2F2", color: "#B91C1C", border: "1px solid #FECACA" }
                                    : { backgroundColor: "#FFFBEB", color: "#A16207", border: "1px solid #FDE68A" })) },
                            kycStatus.toLowerCase() === "verified" ? React.createElement(VerifiedUser, { sx: { fontSize: 13 } }) : React.createElement(WarningAmber, { sx: { fontSize: 13 } }),
                            "KYC: ",
                            kycStatus.charAt(0).toUpperCase() + kycStatus.slice(1).toLowerCase())),
                        accountType && accountType !== "NA" && (React.createElement(Box, { sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                px: 1.25,
                                py: 0.5,
                                borderRadius: "6px",
                                fontSize: 12,
                                fontWeight: 600,
                                fontFamily: "Poppins",
                                backgroundColor: "#EFF6FF",
                                color: "#1D4ED8",
                                border: "1px solid #BFDBFE",
                            } },
                            React.createElement(StorefrontOutlined, { sx: { fontSize: 13 } }),
                            formattedAccountType(accountType))),
                        tenantType && tenantType !== "NA" && (React.createElement(Box, { sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                px: 1.25,
                                py: 0.5,
                                borderRadius: "6px",
                                fontSize: 12,
                                fontWeight: 500,
                                fontFamily: "Poppins",
                                backgroundColor: "#F8FAFC",
                                color: "#475569",
                                border: "1px solid #E2E8F0",
                            } }, tenantType))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: {
                        mb: 2,
                        borderLeft: "4px solid",
                        borderLeftColor: kycStatus.toLowerCase() === "verified"
                            ? "#22C55E"
                            : kycStatus.toLowerCase() === "rejected"
                                ? "#EF4444"
                                : kycStatus
                                    ? "#F59E0B"
                                    : "#E2E8F0",
                    } },
                    React.createElement(CardContent, { sx: { pb: "20px !important" } },
                        React.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 },
                            React.createElement(Typography, { className: "tm_section_title" }, "Tenant Details"),
                            React.createElement(Box, { sx: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    backgroundColor: "#F8FAFC",
                                    color: "#94A3B8",
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "6px",
                                    px: 1,
                                    py: 0.4,
                                    fontSize: 11,
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                } },
                                React.createElement(LockOutlined, { sx: { fontSize: 11 } }),
                                "Read Only")),
                        React.createElement(Divider, { className: "tm_divider" }),
                        React.createElement(Grid, { container: true, spacing: 0, sx: { mt: 1 } },
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5 } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Tenant ID"),
                                React.createElement(Box, { display: "flex", alignItems: "center", gap: 0.5 },
                                    React.createElement(Typography, { className: "tenant_value", sx: { fontFamily: "monospace", fontSize: "13px !important", color: "#334155" } }, tenantId),
                                    React.createElement(Tooltip, { title: "Copy Tenant ID" },
                                        React.createElement(IconButton, { size: "small", onClick: handleCopyTenantId, sx: {
                                                p: 0.5,
                                                color: "#94A3B8",
                                                borderRadius: "4px",
                                                "&:hover": { color: "#1D4ED8", backgroundColor: "#EFF6FF" },
                                                transition: "all 150ms ease",
                                            } },
                                            React.createElement(ContentCopy, { sx: { fontSize: 13 } }))))),
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5, borderLeft: "1px solid #F1F5F9" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Company Name"),
                                React.createElement(Typography, { className: "tenant_value", sx: { fontWeight: "500 !important", color: "#0f172a !important" } }, companyName)),
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5, borderLeft: "1px solid #F1F5F9" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "KYC Status"),
                                React.createElement(Box, { display: "flex", alignItems: "center", gap: 0.75 },
                                    kycStatus.toLowerCase() === "verified" ? (React.createElement(VerifiedUser, { sx: { fontSize: 15, color: "#16A34A" } })) : kycStatus.toLowerCase() === "rejected" ? (React.createElement(WarningAmber, { sx: { fontSize: 15, color: "#DC2626" } })) : null,
                                    React.createElement("span", { className: getKycBadgeClass(kycStatus) }, kycStatus ? kycStatus.charAt(0).toUpperCase() + kycStatus.slice(1).toLowerCase() : "—")))),
                        React.createElement(Divider, { sx: { borderColor: "#F1F5F9" } }),
                        React.createElement(Grid, { container: true, spacing: 0 },
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5 } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Created At"),
                                React.createElement(Typography, { className: "tenant_value" }, getDateString(+createdAt, "MM-DD-YYYY hh:mm a"))),
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5, borderLeft: "1px solid #F1F5F9" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Tenant Type"),
                                React.createElement(Typography, { className: "tenant_value" }, tenantType)),
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5, borderLeft: "1px solid #F1F5F9" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Account Type"),
                                React.createElement(Box, { sx: {
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 0.5,
                                        px: 1.25,
                                        py: 0.4,
                                        borderRadius: "6px",
                                        fontSize: 12,
                                        fontWeight: 600,
                                        fontFamily: "Poppins",
                                        backgroundColor: "#EFF6FF",
                                        color: "#1D4ED8",
                                        border: "1px solid #BFDBFE",
                                    } },
                                    React.createElement(StorefrontOutlined, { sx: { fontSize: 13 } }),
                                    formattedAccountType(accountType)))),
                        React.createElement(Divider, { sx: { borderColor: "#F1F5F9" } }),
                        React.createElement(Grid, { container: true, spacing: 0 },
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5 } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Primary User Name"),
                                React.createElement(Typography, { className: "tenant_value" }, userName)),
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5, borderLeft: "1px solid #F1F5F9" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Primary User Email ID"),
                                React.createElement(Typography, { className: "tenant_value" }, emailId)),
                            React.createElement(Grid, { item: true, xs: 4, sx: { px: 1.5, py: 1.5, borderLeft: "1px solid #F1F5F9" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Primary Phone Number"),
                                React.createElement(Typography, { className: "tenant_value" }, phoneNumber)))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2, borderLeft: "4px solid #6366F1" } },
                    React.createElement(CardContent, null,
                        React.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5, mb: 1 },
                            React.createElement(Box, { sx: {
                                    width: 34,
                                    height: 34,
                                    borderRadius: "9px",
                                    backgroundColor: "#EEF2FF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                } },
                                React.createElement(ManageAccounts, { sx: { fontSize: 18, color: "#6366F1" } })),
                            React.createElement(Box, null,
                                React.createElement(Typography, { className: "tm_section_title" }, "Change Account Type"),
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 11, color: "#64748B", lineHeight: 1.4 } }, "Modify billing mode and COD deduction settings"))),
                        React.createElement(Divider, { className: "tm_divider" }),
                        React.createElement(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                p: 1.5,
                                mb: 2,
                                mt: 1.5,
                                backgroundColor: "#F8FAFC",
                                borderRadius: "8px",
                                border: "1px solid #E2E8F0",
                            } },
                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#64748B", fontWeight: 500 } }, "Current:"),
                            React.createElement("span", { className: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.accountType) === "PREPAID" ? "tm_badge_prepaid" : "tm_badge_postpaid" }, (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.accountType) === "PREPAID" ? "Prepaid" : "Postpaid"),
                            React.createElement(Box, { sx: { width: "1px", height: 16, backgroundColor: "#CBD5E1" } }),
                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#64748B", fontWeight: 500 } }, "COD Deduction:"),
                            React.createElement(Box, { sx: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    px: 1.25,
                                    py: 0.4,
                                    borderRadius: "6px",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    fontFamily: "Poppins",
                                    backgroundColor: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "#F0FDF4" : "#FEF2F2",
                                    color: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "#15803D" : "#B91C1C",
                                    border: `1px solid ${(activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "#BBF7D0" : "#FECACA"}`,
                                } }, (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "Enabled" : "Disabled")),
                        React.createElement(Grid, { container: true, spacing: 2, alignItems: "flex-end" },
                            React.createElement(Grid, { item: true, xs: 4 },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "New Account Type"),
                                React.createElement(Select, { fullWidth: true, size: "small", value: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.accountType) || "", onChange: (e) => setActiveAccountType((prev) => (prev ? Object.assign(Object.assign({}, prev), { accountType: e.target.value }) : prev)), className: "tenant_value tm_select", sx: { borderRadius: "8px" } },
                                    React.createElement(MenuItem, { value: "PREPAID" }, "Prepaid"),
                                    React.createElement(MenuItem, { value: "POSTPAID" }, "Postpaid"))),
                            React.createElement(Grid, { item: true, xs: 4 },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "COD Deduction"),
                                React.createElement(Select, { fullWidth: true, size: "small", value: String(activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible), onChange: (e) => setActiveAccountType((prev) => (prev ? Object.assign(Object.assign({}, prev), { isCodDeductible: e.target.value === "true" }) : prev)), className: "tenant_value tm_select", sx: { borderRadius: "8px" } },
                                    React.createElement(MenuItem, { value: "true" }, "Enable"),
                                    React.createElement(MenuItem, { value: "false" }, "Disable"))),
                            React.createElement(Grid, { item: true, xs: 4 },
                                React.createElement(Button, { variant: "contained", fullWidth: true, className: "tm_btn_primary", sx: { textTransform: "none", py: 1 }, onClick: () => setAccountTypeConfirmOpen(true) }, "Save Changes")))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2, borderLeft: "4px solid #E2E8F0" } },
                    React.createElement(CardContent, null,
                        React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 },
                            React.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5 },
                                React.createElement(Box, { sx: {
                                        width: 34,
                                        height: 34,
                                        borderRadius: "9px",
                                        backgroundColor: "#F1F5F9",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    } },
                                    React.createElement(ReceiptLong, { sx: { fontSize: 18, color: "#64748B" } })),
                                React.createElement(Box, null,
                                    React.createElement(Typography, { className: "tm_section_title" }, "COD Deduction Configuration"),
                                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 11, color: "#64748B", lineHeight: 1.4 } }, "Derived from account type settings"))),
                            React.createElement(Box, { sx: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    backgroundColor: "#F8FAFC",
                                    color: "#94A3B8",
                                    border: "1px solid #E2E8F0",
                                    borderRadius: "6px",
                                    px: 1,
                                    py: 0.4,
                                    fontSize: 11,
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                } },
                                React.createElement(LockOutlined, { sx: { fontSize: 11 } }),
                                "Read Only")),
                        React.createElement(Divider, { className: "tm_divider" }),
                        React.createElement(Box, { sx: {
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1,
                                p: 1.5,
                                mb: 2,
                                mt: 1.5,
                                backgroundColor: "#FFFBEB",
                                borderRadius: "8px",
                                border: "1px solid #FDE68A",
                            } },
                            React.createElement(InfoOutlined, { sx: { color: "#D97706", fontSize: 16, mt: 0.1, flexShrink: 0 } }),
                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#92400E", lineHeight: 1.6 } },
                                "This setting is controlled by the account type configuration. To change it, update the ",
                                React.createElement("strong", null, "Change Account Type"),
                                " card above.")),
                        React.createElement(Box, null,
                            React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Deduct Shipment Charges from COD Remittance"),
                            React.createElement(Box, { sx: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    px: 1.5,
                                    py: 0.75,
                                    borderRadius: "8px",
                                    fontSize: 13,
                                    fontWeight: 600,
                                    fontFamily: "Poppins",
                                    backgroundColor: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "#F0FDF4" : "#FEF2F2",
                                    color: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "#15803D" : "#B91C1C",
                                    border: `1px solid ${(activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "#BBF7D0" : "#FECACA"}`,
                                } }, (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "Yes — Enabled" : "No — Disabled"))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2 } },
                    React.createElement(CardContent, null,
                        React.createElement(Typography, { className: "tm_section_title", mb: 1 }, "KYC Details"),
                        React.createElement(Divider, { className: "tm_divider", sx: { mb: 2 } }),
                        kycStatus && (React.createElement(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                p: 1.5,
                                mb: 2,
                                borderRadius: "8px",
                                backgroundColor: kycStatus.toLowerCase() === "verified" ? "#F0FDF4" : kycStatus.toLowerCase() === "rejected" ? "#FEF2F2" : "#FFFBEB",
                                border: `1px solid ${kycStatus.toLowerCase() === "verified" ? "#86EFAC" : kycStatus.toLowerCase() === "rejected" ? "#FCA5A5" : "#FCD34D"}`,
                            } },
                            kycStatus.toLowerCase() === "verified" ? (React.createElement(CheckCircle, { sx: { color: "#16A34A", fontSize: 18 } })) : (React.createElement(WarningAmber, { sx: { color: kycStatus.toLowerCase() === "rejected" ? "#DC2626" : "#D97706", fontSize: 18 } })),
                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 13, fontWeight: 600, color: "#0f172a" } },
                                "KYC Status:",
                                " ",
                                React.createElement("span", { style: {
                                        color: kycStatus.toLowerCase() === "verified" ? "#15803D" : kycStatus.toLowerCase() === "rejected" ? "#B91C1C" : "#A16207",
                                    } }, kycStatus.charAt(0).toUpperCase() + kycStatus.slice(1).toLowerCase())))),
                        React.createElement(KYCdetails, null),
                        React.createElement(Grid, { item: true, xs: 12, sx: { mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 } },
                            React.createElement(Button, { variant: "outlined", className: "tm_btn_danger", startIcon: React.createElement(WarningAmber, null), sx: { textTransform: "none", px: 3 }, onClick: () => {
                                    setPendingKycAction("rejected");
                                    setKycConfirmOpen(true);
                                } }, "Reject KYC"),
                            React.createElement(Button, { variant: "contained", className: "tm_btn_success", startIcon: React.createElement(CheckCircle, null), sx: { textTransform: "none", px: 3 }, onClick: () => {
                                    setPendingKycAction("verified");
                                    setKycConfirmOpen(true);
                                } }, "Approve KYC"))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2, borderLeft: "4px solid #3802b5" } },
                    React.createElement(CardContent, null,
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "GST Declaration"),
                        React.createElement(Divider, { className: "m_divider", sx: { mb: 2 } }),
                        declarationExist && (React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between", mt: 0.5 },
                            React.createElement(Grid, { item: true, xs: 6 },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Download GST declaration form"),
                                React.createElement(Button, { variant: "outlined", onClick: handleDownloadDeclaration, className: "tm_btn_danger", startIcon: React.createElement(DownloadIcon, null), sx: { textTransform: "none", px: 3 } }, "Download")),
                            React.createElement(Grid, { item: true, xs: 6, sx: { mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 } },
                                React.createElement(Button, { variant: "outlined", className: "tm_btn_danger", startIcon: React.createElement(WarningAmber, null), sx: { textTransform: "none", px: 3 }, onClick: () => handleDeclarationStateUpdate("REJECTED", "GST_DECLARATION") }, "Reject"),
                                React.createElement(Button, { variant: "contained", className: "tm_btn_success", startIcon: React.createElement(CheckCircle, null), sx: { textTransform: "none", px: 3 }, onClick: () => handleDeclarationStateUpdate("APPROVED", "GST_DECLARATION") }, "Approve")))),
                        React.createElement(Divider, { className: "m_divider", sx: { mb: 1, mt: 1 } }),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontWeight: 600, fontSize: "14px", color: "#0f172a", mb: 1.5 } }, "GST Certificates"),
                        React.createElement(TableContainer, { sx: { border: "1px solid #E2E8F0", borderRadius: "8px", overflow: "hidden" } },
                            React.createElement(Table, { size: "small" },
                                React.createElement(TableHead, null,
                                    React.createElement(TableRow, { sx: { backgroundColor: "#F8FAFC" } },
                                        React.createElement(TableCell, { sx: {
                                                fontFamily: "Poppins",
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: "#94A3B8",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.3px",
                                                width: 220,
                                            } }, "GST Number"),
                                        React.createElement(TableCell, { sx: {
                                                fontFamily: "Poppins",
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: "#94A3B8",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.3px",
                                                width: 140,
                                            } }, "Status"),
                                        React.createElement(TableCell, { sx: {
                                                fontFamily: "Poppins",
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: "#94A3B8",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.3px",
                                                width: 160,
                                            } }, "Certificate"),
                                        React.createElement(TableCell, { sx: {
                                                fontFamily: "Poppins",
                                                fontSize: 11,
                                                fontWeight: 600,
                                                color: "#94A3B8",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.3px",
                                                width: 220,
                                            } }))),
                                React.createElement(TableBody, null, gstCertList.length === 0 ? (React.createElement(TableRow, null,
                                    React.createElement(TableCell, { colSpan: 4, sx: { fontFamily: "Poppins", fontSize: 13, color: "#94A3B8", textAlign: "center", py: 3 } }, "No GST certificates found."))) : (gstCertList.map((cert) => (React.createElement(TableRow, { key: cert.gstNumber, sx: { "&:last-child td": { borderBottom: 0 } } },
                                    React.createElement(TableCell, null,
                                        React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 1 } },
                                            React.createElement(Typography, { sx: { fontFamily: "monospace", fontSize: 13, fontWeight: 500, color: "#334155" } }, cert.gstNumber),
                                            cert.isDefault && (React.createElement(Box, { sx: {
                                                    fontSize: 10,
                                                    fontWeight: 600,
                                                    fontFamily: "Poppins",
                                                    color: "#1D4ED8",
                                                    backgroundColor: "#EFF6FF",
                                                    border: "1px solid #BFDBFE",
                                                    borderRadius: "4px",
                                                    px: 0.75,
                                                    py: 0.25,
                                                    flexShrink: 0,
                                                } }, "DEFAULT")))),
                                    React.createElement(TableCell, null,
                                        React.createElement("span", { className: getGstCertBadgeClass(cert.verificationStatus) }, formatGstCertStatus(cert.verificationStatus))),
                                    React.createElement(TableCell, null,
                                        React.createElement(Button, { variant: "outlined", onClick: () => handleDownloadGstCertificate(cert), className: "tm_btn_danger", startIcon: React.createElement(DownloadIcon, null), sx: { textTransform: "none", px: 3 } }, "Download")),
                                    React.createElement(TableCell, null, cert.verificationStatus === "PENDING" && (React.createElement(Box, { sx: { display: "flex", justifyContent: "flex-end", gap: 1 } },
                                        React.createElement(Button, { variant: "outlined", size: "small", className: "tm_btn_danger", startIcon: React.createElement(WarningAmber, { sx: { fontSize: 14 } }), sx: { textTransform: "none", px: 2 }, onClick: () => handleGstCertStateUpdate(cert.gstNumber, "REJECTED", "GST_CERTIFICATE") }, "Reject"),
                                        React.createElement(Button, { variant: "contained", size: "small", className: "tm_btn_success", startIcon: React.createElement(CheckCircle, { sx: { fontSize: 14 } }), sx: { textTransform: "none", px: 2 }, onClick: () => handleGstCertStateUpdate(cert.gstNumber, "APPROVED", "GST_CERTIFICATE") }, "Approve")))))))))))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2, borderLeft: "4px solid #8B5CF6" } },
                    React.createElement(CardContent, null,
                        React.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5, mb: 1 },
                            React.createElement(Box, { sx: {
                                    width: 34,
                                    height: 34,
                                    borderRadius: "9px",
                                    backgroundColor: "#F5F3FF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                } },
                                React.createElement(LayersOutlined, { sx: { fontSize: 18, color: "#7C3AED" } })),
                            React.createElement(Box, null,
                                React.createElement(Typography, { className: "tm_section_title" }, "Seller Wallet Plan Configuration"),
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 11, color: "#64748B", lineHeight: 1.4 } }, "Manage the tenant's wallet tier and negative balance limits"))),
                        React.createElement(Divider, { className: "tm_divider" }),
                        React.createElement(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                p: 1.5,
                                mb: 2,
                                mt: 1.5,
                                backgroundColor: "#F8FAFC",
                                borderRadius: "8px",
                                border: "1px solid #E2E8F0",
                            } },
                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#64748B", fontWeight: 500 } }, "Active Plan:"),
                            activePlan ? (React.createElement("span", { className: "tm_plan_chip" }, activePlan)) : (React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#94A3B8" } }, "No plan assigned"))),
                        React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: 2 } },
                            React.createElement(Box, { sx: { flex: "0 0 260px" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Change Wallet Plan"),
                                React.createElement(Select, { fullWidth: true, size: "small", value: selectedTier, className: "tenant_value tm_select", onChange: (e) => setSelectedTier(e.target.value), sx: { borderRadius: "8px" } }, walletTiers.map((tier) => (React.createElement(MenuItem, { key: tier.tierName, value: tier.tierName }, tier.tierName)))),
                                selectedTierData && (React.createElement(Typography, { className: "tm_plan_helper" },
                                    "Negative wallet limit: \u20B9", (_b = selectedTierData.negativeWalletLimit) === null || _b === void 0 ? void 0 :
                                    _b.toLocaleString("en-IN")))),
                            React.createElement(Box, { sx: { pt: "22px" } },
                                React.createElement(Button, { variant: "contained", className: "tm_btn_primary", sx: { textTransform: "none", py: 1, px: 4, minWidth: 120 }, onClick: HandleSaveWalletPlan }, "Save Plan")))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2, borderLeft: "4px solid #0EA5E9" } },
                    React.createElement(CardContent, null,
                        React.createElement(Box, { display: "flex", alignItems: "center", gap: 1.5, mb: 1 },
                            React.createElement(Box, { sx: {
                                    width: 34,
                                    height: 34,
                                    borderRadius: "9px",
                                    backgroundColor: "#F0F9FF",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                } },
                                React.createElement(EventRepeat, { sx: { fontSize: 18, color: "#0369A1" } })),
                            React.createElement(Box, null,
                                React.createElement(Typography, { className: "tm_section_title" }, "Remittance / Payout Cycle"),
                                React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 11, color: "#64748B", lineHeight: 1.4 } }, "Days of the week on which COD amounts are remitted after calculation"))),
                        React.createElement(Divider, { className: "tm_divider" }),
                        React.createElement(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                p: 1.5,
                                mb: 2,
                                mt: 1.5,
                                backgroundColor: "#F8FAFC",
                                borderRadius: "8px",
                                border: "1px solid #E2E8F0",
                            } },
                            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#64748B", fontWeight: 500 } }, "Active Cycle:"),
                            activePayoutCycle ? (React.createElement(Box, { sx: {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    px: 1.25,
                                    py: 0.4,
                                    borderRadius: "6px",
                                    fontSize: 12,
                                    fontWeight: 600,
                                    fontFamily: "Poppins",
                                    backgroundColor: "#EFF6FF",
                                    color: "#1D4ED8",
                                    border: "1px solid #BFDBFE",
                                } },
                                activePayoutCycle,
                                " Days a week")) : (React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#94A3B8" } }, "Not configured"))),
                        React.createElement(Box, { sx: { display: "flex", alignItems: "flex-start", gap: 2 } },
                            React.createElement(Box, { sx: { flex: "0 0 340px" } },
                                React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Change Payout Cycle"),
                                React.createElement(Select, { fullWidth: true, size: "small", value: selectedPayoutCycle, className: "tenant_value tm_select", onChange: (e) => setSelectedPayoutCycle(e.target.value), sx: { borderRadius: "8px" } },
                                    React.createElement(MenuItem, { value: "2" }, "2 Days a week \u2014 Tuesday & Friday"),
                                    React.createElement(MenuItem, { value: "3" }, "3 Days a week \u2014 Mon, Wed & Fri"),
                                    React.createElement(MenuItem, { value: "5" }, "5 Days a week \u2014 Monday to Friday"))),
                            React.createElement(Box, { sx: { pt: "22px" } },
                                React.createElement(Button, { variant: "contained", disabled: !selectedPayoutCycle, className: "tm_btn_primary", sx: { textTransform: "none", py: 1, px: 4, minWidth: 120 }, onClick: HandleSaveRemittancePayoutCycle }, "Save Cycle")))))),
            React.createElement(Grid, { item: true },
                React.createElement(Card, { variant: "outlined", className: "tm_card", sx: { mb: 2 } },
                    React.createElement(CardContent, null,
                        React.createElement(Typography, { className: "tm_section_title", mb: 0.5 }, "Billing Cycle"),
                        React.createElement(Typography, { className: "tm_section_subtitle", mb: 1 }, "Define the days on which COD calculation will be done."),
                        React.createElement(Divider, { className: "tm_divider" }),
                        React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                                React.createElement(Paper, { className: "tm_billing_card", elevation: 0 },
                                    React.createElement("span", { className: "tm_billing_label" }, "Current Billing Cycle"),
                                    React.createElement(Typography, { className: "tm_billing_value", mt: 0.5, mb: 1.5 }, currentBillingCycle || "NA"),
                                    React.createElement("span", { className: "tm_billing_label" }, "Start Date"),
                                    React.createElement(Box, { className: "tm_billing_date", mt: 0.5 },
                                        React.createElement(CalendarToday, { sx: { fontSize: 13 } }),
                                        currentBillingCycleStartTimestamp ? getDateString(Number(currentBillingCycleStartTimestamp), "Do MMM hh:mm A") : "—"))),
                            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                                React.createElement(Paper, { className: "tm_billing_card", elevation: 0 },
                                    React.createElement("span", { className: "tm_billing_label" }, "Upcoming Billing Cycle"),
                                    React.createElement(Typography, { className: "tm_billing_value", mt: 0.5, mb: 1.5 }, upcomingBillingCycle || "NA"),
                                    React.createElement("span", { className: "tm_billing_label" }, "Upcoming Start Date"),
                                    React.createElement(Box, { className: "tm_billing_date", mt: 0.5 },
                                        React.createElement(CalendarToday, { sx: { fontSize: 13 } }),
                                        upcomingBillingCycleStartTimestamp ? getDateString(Number(upcomingBillingCycleStartTimestamp), "Do MMM hh:mm A") : "—"))))))),
            React.createElement(Dialog, { open: accountTypeConfirmOpen, onClose: () => setAccountTypeConfirmOpen(false), maxWidth: "xs", fullWidth: true },
                React.createElement(DialogTitle, { sx: { fontFamily: "Poppins", fontWeight: 600, fontSize: 16 } }, "Confirm Account Type Change"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { sx: { fontFamily: "Poppins", fontSize: 14 } },
                        "Are you sure you want to change the account type to",
                        " ",
                        React.createElement("strong", null, (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.accountType) === "PREPAID" ? "Prepaid" : "Postpaid"),
                        "? This will affect billing and COD deduction configurations.")),
                React.createElement(DialogActions, { sx: { px: 3, pb: 2, gap: 1 } },
                    React.createElement(Button, { onClick: () => setAccountTypeConfirmOpen(false), variant: "outlined", sx: { textTransform: "none", fontFamily: "Poppins", borderRadius: "8px", borderColor: "#CBD5E1", color: "#64748B" } }, "Cancel"),
                    React.createElement(Button, { onClick: () => {
                            setAccountTypeConfirmOpen(false);
                            handleSaveAccountType();
                        }, variant: "contained", className: "tm_btn_primary", sx: { textTransform: "none" } }, "Confirm Change"))),
            React.createElement(Dialog, { open: kycConfirmOpen, onClose: () => setKycConfirmOpen(false), maxWidth: "xs", fullWidth: true },
                React.createElement(DialogTitle, { sx: { fontFamily: "Poppins", fontWeight: 600, fontSize: 16 } },
                    "Confirm KYC ",
                    pendingKycAction === "verified" ? "Approval" : "Rejection"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { sx: { fontFamily: "Poppins", fontSize: 14 } },
                        "Are you sure you want to",
                        " ",
                        React.createElement("strong", { style: { color: pendingKycAction === "verified" ? "#15803D" : "#B91C1C" } }, pendingKycAction === "verified" ? "approve" : "reject"),
                        " ",
                        "the KYC for ",
                        React.createElement("strong", null, companyName || tenantId),
                        "? This action will update the tenant's KYC status immediately.")),
                React.createElement(DialogActions, { sx: { px: 3, pb: 2, gap: 1 } },
                    React.createElement(Button, { onClick: () => setKycConfirmOpen(false), variant: "outlined", sx: { textTransform: "none", fontFamily: "Poppins", borderRadius: "8px", borderColor: "#CBD5E1", color: "#64748B" } }, "Cancel"),
                    React.createElement(Button, { onClick: () => {
                            setKycConfirmOpen(false);
                            handleKYCstateUpdate(pendingKycAction);
                        }, variant: "contained", className: pendingKycAction === "verified" ? "tm_btn_success" : "", sx: Object.assign({ textTransform: "none" }, (pendingKycAction === "rejected" && {
                            backgroundColor: "#EF4444",
                            "&:hover": { backgroundColor: "#DC2626" },
                            borderRadius: "8px",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                        })) }, pendingKycAction === "verified" ? "Approve KYC" : "Reject KYC"))))));
};
export default TenantManagerDetails;
